<template>
    <v-dialog v-model="dialog" width="auto" content-class="resultsBySubject-dialog">
        <div class="resultsBySubject-container">
            <button class="close" @click.prevent="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
            <div class="resultsBySubject_body" :style="`width: ${dialogBodyWidth}px; max-height: ${dialogBodyHeight}px`">
                <h1 class="grade_item-name">Аналитика прохождения заданий по дисциплинам</h1>
                <div ref="chartContainer" class="body-container">
                    <ResultsBySubjectChart ref="chart" :height="chartHeight" :loading="false" />
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import ResultsBySubjectChart from './chart.vue';
import './dialog.scss';

export default {
    name: 'ResultsBySubjectDialog',
    components: { ResultsBySubjectChart },
    props: {
        categories: { type: Array, required: true },
        series: { type: Array, required: true }
    },
    data: () => ({
        dialogBodyWidth: 0,
        dialogBodyHeight: 0,
        chartHeight: 0,
        dialog: false,
    }),
    methods: {
        open() {
            this.dialog = true;

            this.$nextTick(() => {
                this.$refs.chart.update(this.categories, this.series);
                this.$refs.chartContainer.scrollTop = 0;
            });
        },
        close() {
            this.dialog = false;
            this.$emit('close');
        }
    },
    created() {
        let margin = 48;
        let buttonSize = 36;

        this.dialogBodyWidth = Math.floor(window.innerWidth * 0.9);
        let dialogWidth = this.dialogBodyWidth + margin + buttonSize;

        if (dialogWidth > window.innerWidth) {
            this.dialogBodyWidth = window.innerWidth - margin - buttonSize;
        }

        this.dialogBodyHeight = Math.floor(window.innerHeight * 0.9) - buttonSize;
        this.chartHeight = this.dialogBodyHeight - 64 - 36 - 24;
    }
}
</script>
